import { Injectable } from '@angular/core';
import { EMPTY, Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ApiModels } from '@mona/api';
import { TokenStorageService } from '@mona/auth';
import { ConfigService } from '@mona/config';
import { Encounter, MonaNotification } from '@mona/models';
import { WsExtendableService } from '@mona/shared/utils';
import { transformApiNotification } from './transforms';

/**
 * Websocket service for notifications
 */
@Injectable({ providedIn: 'root' })
export class NotificationsWsService extends WsExtendableService<MonaNotification> {
    /**
     * Constructor
     *
     * @param configService ConfigService
     * @param tokenStorage
     */
    constructor(private configService: ConfigService, private tokenStorage: TokenStorageService) {
        super();
    }

    /**
     * Connects to ws for notifications
     *
     * @param encounterId EntityId<Encounter>
     */
    connect(encounterId: EntityId<Encounter>): Observable<MonaNotification> {
        return of(this.tokenStorage.getAccessToken()).pipe(
            switchMap(accessToken => {
                const url = `${this.configService.get('api.coreWsUrl')}/ws/notifications/${encounterId}/`;
                this.setConfig(url, accessToken);
                return super.connect();
            }),
            map((message: { type: string; notification: ApiModels.Notification }) =>
                transformApiNotification(message.notification),
            ),
            catchError(e => EMPTY),
        );
    }
}
